module.exports = __webpack_public_path__ + "img/metal_ak@2x.a58a1587.png";